import { inject } from '@angular/core';
import { PermisosService } from '@core/services/permisos.service';
import { PestanaNavegacion } from '@shared/componentes/pestanas-navegacion/pestanas-navegacion.constants';

export function filtrarPestanasPermitidas<T extends PestanaNavegacion>(
  pestanas: readonly T[],
  permisosService: PermisosService
): T[] {
  return pestanas.filter(pestana => permisosService.tieneAlgunPermiso([...pestana.permisos]));
}

export function redirigirAPrimeraPestanaPermitida(pestanas: readonly PestanaNavegacion[]): () => string {
  return () => {
    const [primeraPermitida] = filtrarPestanasPermitidas(pestanas, inject(PermisosService));
    return (primeraPermitida ?? pestanas[0]).ruta;
  };
}
